webpackJsonp([35783957827783,222309558401364,241894665707670],{

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Crystal_Glyph_Color.317b7189.png";

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crystal-kvis_small.6dc45424.png";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crystal_intro_video.fb5f5ee6.mp4";

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/video_thumbnail.0d6e4478.png";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _template = __webpack_require__(54);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _reactRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    requestDemoFormOpen: (0, _lodash.get)(state, "requestDemoFormOpen")
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    closePanel: function closePanel() {
	      return dispatch({ type: "CLOSE_REQUEST_DEMO_FORM" });
	    }
	  };
	};
	
	var ConnectedRequestDemoForm = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_template2.default);
	
	exports.default = ConnectedRequestDemoForm;
	module.exports = exports["default"];

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RequestDemoForm":"src-components-RequestDemoForm----style-module---RequestDemoForm---2goRf","enter":"src-components-RequestDemoForm----style-module---enter---2GSXH","enterActive":"src-components-RequestDemoForm----style-module---enterActive---Um1KY","exit":"src-components-RequestDemoForm----style-module---exit---UjCXo","exitActive":"src-components-RequestDemoForm----style-module---exitActive---xxWPc","open":"src-components-RequestDemoForm----style-module---open---2LsZx","formSide":"src-components-RequestDemoForm----style-module---formSide---2bKUY","closeSvg":"src-components-RequestDemoForm----style-module---closeSvg---2gFhA","submitApplicationForm":"src-components-RequestDemoForm----style-module---submitApplicationForm---2ROvi"};

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactTransitionGroup = __webpack_require__(36);
	
	var _styleModule = __webpack_require__(62);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	var _Translator = __webpack_require__(10);
	
	var _Translator2 = _interopRequireDefault(_Translator);
	
	var _FormField = __webpack_require__(52);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fieldsBySections = [{
	  fields: [{
	    col: 6,
	    label: "First name*",
	    labelInline: false,
	    name: "first_name",
	    type: "text",
	    placeholder: "Enter your first name",
	    validationFunction: Boolean,
	    groupID: "merge_fields",
	    defaultValue: ""
	  }, {
	    col: 6,
	    label: "Last name*",
	    labelInline: false,
	    name: "last_name",
	    type: "text",
	    placeholder: "Enter your last name",
	    validationFunction: Boolean,
	    groupID: "merge_fields",
	    defaultValue: ""
	  }, {
	    col: 6,
	    label: "Work email*",
	    labelInline: false,
	    name: "email",
	    type: "email",
	    placeholder: "Enter your work email",
	    validationFunction: function validationFunction(v) {
	      return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)
	      );
	    },
	    groupID: "merge_fields",
	    defaultValue: ""
	  }, {
	    col: 6,
	    label: "Company Name*",
	    labelInline: false,
	    name: "company",
	    type: "text",
	    placeholder: "Enter your company name",
	    validationFunction: Boolean,
	    groupID: "merge_fields",
	    defaultValue: ""
	  }, {
	    col: 6,
	    label: "Industry",
	    labelInline: false,
	    name: "industry",
	    type: "text",
	    placeholder: "Enter your industry",
	    validationFunction: function validationFunction() {
	      return true;
	    },
	    groupID: "merge_fields",
	    defaultValue: ""
	  }, {
	    col: 12,
	    label: "Why would you like to use crystal? (optional)",
	    labelInline: false,
	    name: "00N7Q000004pcI0",
	    type: "textarea",
	    placeholder: "I’d like to use crystal because my team needs help getting data insights faster",
	    validationFunction: function validationFunction() {
	      return true;
	    },
	    groupID: "merge_fields",
	    defaultValue: ""
	  }]
	}, {
	  fields: [{
	    col: 12,
	    label: "I accept the ",
	    labelInline: true,
	    name: "terms_and_conditions",
	    type: "checkbox",
	    validationFunction: function validationFunction(v) {
	      return v;
	    },
	    groupID: "marketing_permissions",
	    defaultValue: false,
	    labelLink: "https://crystal.ai/en/legal/terms-and-conditions/",
	    labelLinkText: "Terms & Conditions"
	  }, {
	    col: 12,
	    label: "I'd like to receive your company newsletter by email",
	    labelInline: true,
	    name: "newsletter",
	    type: "checkbox",
	    validationFunction: function validationFunction() {
	      return true;
	    },
	    groupID: "marketing_permissions",
	    defaultValue: false
	  }]
	}];
	
	var formStatuses = {
	  CLEAR: 0,
	  INVALID: 1,
	  VALID: 2,
	  SUCCESS: 3,
	  FORMAT_ERROR: 4,
	  GENERIC_ERROR: 5
	};
	
	var fieldFlatList = fieldsBySections.map(function (f) {
	  return f.fields;
	}).reduce(function (a, f) {
	  return [].concat(a, f);
	}, []);
	
	var RequestDemoForm = function (_Component) {
	  _inherits(RequestDemoForm, _Component);
	
	  function RequestDemoForm(props) {
	    _classCallCheck(this, RequestDemoForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      submitting: false,
	      invalid: true,
	      formStatus: formStatuses.CLEAR,
	
	      formData: fieldFlatList.reduce(function (a, f) {
	        var _extends2, _extends3;
	
	        return _extends({}, a, (_extends3 = {}, _extends3[f.groupID || f.name] = f.groupID === null ? f.defaultValue : _extends({}, a[f.groupID], (_extends2 = {}, _extends2[f.name] = f.defaultValue, _extends2)), _extends3));
	      }, {}),
	      validation: fieldFlatList.reduce(function (a, f) {
	        var _extends4;
	
	        return _extends({}, a, (_extends4 = {}, _extends4[f.name] = f.validationFunction(f.defaultValue), _extends4));
	      }, {})
	    };
	
	    _this.handleFieldChange = _this.handleFieldChange.bind(_this);
	    return _this;
	  }
	
	  RequestDemoForm.prototype.handleFieldChange = function handleFieldChange(_ref) {
	    var name = _ref.name,
	        groupID = _ref.groupID,
	        value = _ref.value,
	        isValid = _ref.isValid;
	
	    this.setState(function (prevState) {
	      var _extends5, _extends6, _extends7;
	
	      return _extends({}, prevState, {
	
	        formData: _extends({}, prevState.formData, (_extends6 = {}, _extends6[groupID || name] = groupID === null ? value : _extends({}, prevState.formData[groupID], (_extends5 = {}, _extends5[name] = value, _extends5)), _extends6)),
	        validation: _extends({}, prevState.validation, (_extends7 = {}, _extends7[name] = isValid, _extends7))
	      });
	    });
	  };
	
	  RequestDemoForm.prototype.renderTitle = function renderTitle() {
	    return _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-12 col-sm-9 margin-bottom-80" },
	        _react2.default.createElement(
	          _Translator2.default,
	          null,
	          function (t) {
	            return _react2.default.createElement(
	              "h2",
	              { className: "font-tt3 margin-bottom-32" },
	              t("Book a demo")
	            );
	          }
	        ),
	        this.renderMessage()
	      )
	    );
	  };
	
	  RequestDemoForm.prototype.renderMessage = function renderMessage() {
	    var formStatus = this.state.formStatus;
	
	    var isSucceed = formStatus === formStatuses.SUCCESS;
	
	    if (isSucceed) {
	      return _react2.default.createElement(
	        _Translator2.default,
	        null,
	        function (t) {
	          return _react2.default.createElement(
	            "span",
	            { className: "font-mini-spacemono font-color-grey" },
	            t("Thank you for getting in touch. Stay tuned for cool content and ideas."),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            t("v2_contacts-confirmation-b")
	          );
	        }
	      );
	    }
	
	    return _react2.default.createElement(
	      _Translator2.default,
	      null,
	      function (t) {
	        return _react2.default.createElement(
	          "span",
	          { className: "font-mini-spacemono font-color-grey" },
	          t("Make every decision data-driven with crystal, a virtual colleague that advises you through your business data. ")
	        );
	      }
	    );
	  };
	
	  RequestDemoForm.prototype.renderFormFields = function renderFormFields() {
	    var _this2 = this;
	
	    var _state = this.state,
	        submitting = _state.submitting,
	        formStatus = _state.formStatus;
	
	    var isSucceed = formStatus === formStatuses.SUCCESS;
	
	    return !isSucceed && fieldsBySections.map(function (section, i) {
	      return _react2.default.createElement(
	        "fieldset",
	        { disabled: submitting, key: i },
	        _react2.default.createElement("input", { type: "hidden", name: "oid", value: "00D7Q000003R0B9" }),
	        _react2.default.createElement("input", { type: "hidden", name: "lead_source", value: "Demo Form" }),
	        _react2.default.createElement("input", { type: "hidden", name: "retURL", value: "https://www.igenius.ai" }),
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          section.fields.map(function (field) {
	            return _react2.default.createElement(_FormField2.default, {
	              key: field.name,
	              field: field,
	              handleFieldChange: _this2.handleFieldChange
	            });
	          })
	        )
	      );
	    });
	  };
	
	  RequestDemoForm.prototype.renderFormSubmit = function renderFormSubmit() {
	    var _state2 = this.state,
	        submitting = _state2.submitting,
	        validation = _state2.validation,
	        formStatus = _state2.formStatus;
	
	    var invalid = Object.values(validation).includes(false);
	    var isSucceed = formStatus === formStatuses.SUCCESS;
	
	    return !isSucceed && _react2.default.createElement(
	      _Translator2.default,
	      null,
	      function (t) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("input", {
	            type: "submit",
	            value: t("v2_contacts-cta"),
	            disabled: submitting || invalid,
	            className: "font-body"
	          }),
	          _react2.default.createElement(
	            "p",
	            { className: "font-mini-spacemono font-color-grey margin-top-24" },
	            "By sending this request, I accept the",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://crystal.ai/en/legal/privacy/" },
	              "Privacy Policy"
	            )
	          )
	        );
	      }
	    );
	  };
	
	  RequestDemoForm.prototype.render = function render() {
	    var _props = this.props,
	        requestDemoFormOpen = _props.requestDemoFormOpen,
	        closePanel = _props.closePanel;
	
	    return _react2.default.createElement(
	      _reactTransitionGroup.CSSTransition,
	      {
	        appear: true,
	        "in": requestDemoFormOpen,
	        timeout: { appear: 150, enter: 150, exit: 300 },
	        classNames: {
	          appear: _styleModule2.default.enter,
	          appearActive: _styleModule2.default.enterActive,
	          appearDone: _styleModule2.default.open,
	          enter: _styleModule2.default.enter,
	          enterActive: _styleModule2.default.enterActive,
	          enterDone: _styleModule2.default.open,
	          exit: _styleModule2.default.exit,
	          exitActive: _styleModule2.default.exitActive
	        },
	        unmountOnExit: true,
	        mountOnEnter: true
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: (0, _classnames2.default)(_styleModule2.default.RequestDemoForm),
	          onScroll: function onScroll(e) {
	            return e.stopPropagation();
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (0, _classnames2.default)(_styleModule2.default.formSide, " d-flex", "aligns-items-center", "justify-content-center")
	          },
	          _react2.default.createElement(
	            "svg",
	            {
	              onClick: closePanel,
	              className: _styleModule2.default.closeSvg,
	              xmlns: "http://www.w3.org/2000/svg",
	              xmlnsXlink: "http://www.w3.org/1999/xlink",
	              width: "32",
	              height: "32",
	              viewBox: "0 0 24 24"
	            },
	            _react2.default.createElement(
	              "defs",
	              null,
	              _react2.default.createElement("path", {
	                id: "closeSvg",
	                d: "M7.06 6l4.42 4.419a.75.75 0 0 1-1.061 1.06L6 7.062 1.581 11.48a.75.75 0 0 1-1.06-1.061L4.938 6 .52 1.58A.75.75 0 0 1 1.58.52L6 4.94 10.42.52a.75.75 0 0 1 1.06 1.06L7.06 6z"
	              })
	            ),
	            _react2.default.createElement(
	              "g",
	              { fill: "none", fillRule: "evenodd" },
	              _react2.default.createElement("path", { d: "M0 24h24V0H0z" }),
	              _react2.default.createElement(
	                "g",
	                { transform: "translate(6 6)" },
	                _react2.default.createElement(
	                  "mask",
	                  { id: "closeSvgMask", fill: "#fff" },
	                  _react2.default.createElement("use", { xlinkHref: "#closeSvg" })
	                ),
	                _react2.default.createElement("use", {
	                  fill: "#BF2A2A",
	                  fillRule: "nonzero",
	                  xlinkHref: "#closeSvg"
	                }),
	                _react2.default.createElement(
	                  "g",
	                  { fill: "#2B2B2B", mask: "url(#closeSvgMask)" },
	                  _react2.default.createElement("path", { d: "M-6-6h24v24H-6z" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              id: "request-demo-form",
	              action: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
	              method: "POST",
	              className: (0, _classnames2.default)(_styleModule2.default.submitApplicationForm)
	              // onSubmit={(e) => {
	              //   this.setState({
	              //     formStatus: formStatuses.SUCCESS,
	              //     submitting: false,
	              //   });
	              // }}
	            },
	            this.renderTitle(),
	            this.renderFormFields(),
	            this.renderFormSubmit()
	          )
	        )
	      )
	    );
	  };
	
	  return RequestDemoForm;
	}(_react.Component);
	
	exports.default = RequestDemoForm;
	module.exports = exports["default"];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(17);
	
	var _template = __webpack_require__(55);
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    openRequestDemoForm: function openRequestDemoForm() {
	      return dispatch({ type: "OPEN_REQUEST_DEMO_FORM" });
	    }
	  };
	};
	
	var ConnectedCrystalPage = (0, _reactRedux.connect)(null, mapDispatchToProps)(_template2.default);
	
	exports.default = ConnectedCrystalPage;
	module.exports = exports["default"];

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"CrystalPage":"src-pages-crystal----style-module---CrystalPage---5FdcO","content":"src-pages-crystal----style-module---content---1e4lC","bodyLineHeight":"src-pages-crystal----style-module---bodyLineHeight---2aQn2","thumbnailWrapper":"src-pages-crystal----style-module---thumbnailWrapper---1QK8z","playButton":"src-pages-crystal----style-module---playButton---2vELp"};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleModule = __webpack_require__(63);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	var _Header = __webpack_require__(29);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _UnderlinedLink = __webpack_require__(18);
	
	var _UnderlinedLink2 = _interopRequireDefault(_UnderlinedLink);
	
	var _SEO = __webpack_require__(22);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _crystalKvis_small = __webpack_require__(72);
	
	var _crystalKvis_small2 = _interopRequireDefault(_crystalKvis_small);
	
	var _Crystal_Glyph_Color = __webpack_require__(71);
	
	var _Crystal_Glyph_Color2 = _interopRequireDefault(_Crystal_Glyph_Color);
	
	var _crystal_intro_video = __webpack_require__(73);
	
	var _crystal_intro_video2 = _interopRequireDefault(_crystal_intro_video);
	
	var _video_thumbnail = __webpack_require__(74);
	
	var _video_thumbnail2 = _interopRequireDefault(_video_thumbnail);
	
	var _RequestDemoForm = __webpack_require__(53);
	
	var _RequestDemoForm2 = _interopRequireDefault(_RequestDemoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var title = "crystal";
	var description = "crystal, created by iGenius";
	
	var CrystalPage = function (_Component) {
	  _inherits(CrystalPage, _Component);
	
	  function CrystalPage() {
	    _classCallCheck(this, CrystalPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      showVideo: false
	    };
	    return _this;
	  }
	
	  CrystalPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var showVideo = this.state.showVideo;
	
	    return _react2.default.createElement(
	      "div",
	      { className: _styleModule2.default.CrystalPage },
	      _react2.default.createElement(_SEO2.default, {
	        title: title,
	        description: description,
	        url: "https://igenius.ai/crystal"
	      }),
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(
	        "section",
	        { className: "row " + _styleModule2.default.content },
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 col-xl-5 font-body" },
	          _react2.default.createElement("img", { src: _Crystal_Glyph_Color2.default, width: 94, alt: "logo of crystal" }),
	          _react2.default.createElement(
	            "h1",
	            { className: "font-tt2 margin-top-24" },
	            "Ask your way"
	          ),
	          _react2.default.createElement(
	            "h1",
	            { className: "font-tt2 margin-bottom-56" },
	            "to better decisions"
	          ),
	          _react2.default.createElement(
	            "p",
	            {
	              className: "font-color-grey margin-bottom-56 " + _styleModule2.default.bodyLineHeight
	            },
	            "Bridge the data skills gap like never before: expand access to business data and the ability to make data-driven decisions every day to everyone in your business with crystal, the virtual advisor for data intelligence created by iGenius."
	          ),
	          _react2.default.createElement(_UnderlinedLink2.default, {
	            label: "Book a Demo",
	            greenLine: true,
	            liftAnimation: true,
	            externalLink: true,
	            active: true,
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this2.props.openRequestDemoForm();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 col-xl-6 offset-xl-1 d-flex justify-content-center margin-top-32" },
	          _react2.default.createElement("img", { src: _crystalKvis_small2.default })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: " col-12 margin-top-104 margin-bottom-104" },
	          showVideo && _react2.default.createElement(
	            "video",
	            { controls: true, autoPlay: true },
	            _react2.default.createElement("source", { src: _crystal_intro_video2.default, type: "video/mp4" })
	          ),
	          !showVideo && _react2.default.createElement(
	            "div",
	            {
	              className: _styleModule2.default.thumbnailWrapper,
	              onClick: function onClick() {
	                return _this2.setState({ showVideo: true });
	              }
	            },
	            _react2.default.createElement("img", { src: _video_thumbnail2.default }),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "font-body font-color-white " + _styleModule2.default.playButton
	              },
	              "Meet crystal",
	              _react2.default.createElement(
	                "svg",
	                {
	                  width: "22",
	                  height: "24",
	                  viewBox: "0 0 22 24",
	                  fill: "none",
	                  xmlns: "http://www.w3.org/2000/svg"
	                },
	                _react2.default.createElement("path", {
	                  d: "M5.2399 2.95996C5.6821 2.96344 6.11598 3.08052 6.4999 3.29996L17.7799 9.81996C18.1619 10.0415 18.4789 10.3594 18.6994 10.742C18.9198 11.1246 19.0358 11.5584 19.0358 12C19.0358 12.4415 18.9198 12.8753 18.6994 13.2579C18.4789 13.6405 18.1619 13.9585 17.7799 14.18L6.4999 20.7C6.11598 20.9194 5.6821 21.0365 5.2399 21.04C4.56972 21.0347 3.92879 20.7648 3.45676 20.289C2.98474 19.8132 2.71988 19.1702 2.7199 18.5V5.49996C2.71988 4.82976 2.98474 4.18672 3.45676 3.71095C3.92879 3.23517 4.56972 2.96524 5.2399 2.95996V2.95996ZM5.2399 0.959961C4.64464 0.959955 4.05524 1.07753 3.50554 1.30593C2.95584 1.53433 2.45667 1.86906 2.03668 2.2909C1.6167 2.71274 1.28418 3.21339 1.05821 3.76409C0.832234 4.31479 0.717264 4.90471 0.719898 5.49996V18.5C0.69824 19.303 0.891935 20.0972 1.28087 20.8C1.66981 21.5029 2.2398 22.0889 2.93168 22.497C3.62355 22.9052 4.41208 23.1208 5.21539 23.1213C6.0187 23.1218 6.8075 22.9073 7.4999 22.5L18.7799 16C19.4696 15.604 20.0427 15.0331 20.4412 14.3448C20.8397 13.6565 21.0496 12.8753 21.0496 12.08C21.0496 11.2846 20.8397 10.5034 20.4412 9.81513C20.0427 9.12686 19.4696 8.55592 18.7799 8.15996L7.4999 1.65996C6.81492 1.25643 6.0349 1.04244 5.2399 1.03996V0.959961Z",
	                  fill: "#F7F9FF"
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 col-xl-6 margin-bottom-144 font-body" },
	          _react2.default.createElement(
	            "h1",
	            { className: "font-tt2 margin-bottom-32" },
	            "Make every decision data-driven"
	          ),
	          _react2.default.createElement(
	            "p",
	            {
	              className: "font-color-grey margin-bottom-56 " + _styleModule2.default.bodyLineHeight
	            },
	            "Start talking with crystal, the virtual colleague that advises you through your business data and guides you from insights to actions."
	          ),
	          _react2.default.createElement(_UnderlinedLink2.default, {
	            label: "Go to crystal",
	            active: true,
	            newTab: true,
	            greenLine: true,
	            liftAnimation: true,
	            externalLink: true,
	            path: "https://crystal.ai"
	          })
	        )
	      ),
	      _react2.default.createElement(_RequestDemoForm2.default, null),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return CrystalPage;
	}(_react.Component);
	
	CrystalPage.propTypes = {};
	
	exports.default = CrystalPage;
	module.exports = exports["default"];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _crystal = __webpack_require__(101);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_crystal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a3e531ff00d478ec65d5.js